import React, { useMemo, useCallback, useState, useEffect } from "react";
// import MainHeader from "./MainHeader";
// import MiniHeader from "./MiniHeader";
import Footer from "./Footer";
import "survey-core/survey-core.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import i18next from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  parsePhoneNumberFromString,
  getCountries,
  getCountryCallingCode,
} from "libphonenumber-js";
import metadata from "libphonenumber-js/metadata.full.json"; // for full country support
import Sidebar from "./Sidebar";
import { Grid , Typography} from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { gTagTracking, trackEvent } from "../utils/UtilityFunctions";
import { useSelector } from "react-redux";
import HomeIcon from '@mui/icons-material/Home';


// const ALOXA_FEEDBACK_EXCEL_URL =
//   "https://script.google.com/macros/s/AKfycbzKklhzkjKSCBEKHXrKvNLt37n79EVPchQ5JXvCFWU455jryYQ-GNHngD3ly1IPdedp6g/exec";

const ALOXA_FEEDBACK_EXCEL_URL =
  "https://script.google.com/macros/s/AKfycbxloTPTuwufQkSRPXzKAV5KZ8P8zFrMrC5SuxUOng5ZOyQFxP_cSZmua6xgRaevYo1g/exec";

const europeanCountryCodes = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE',  // Sweden
  // "CH", // Switzerland
  // "IN"
];
const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
const choices = europeanCountryCodes.map(code => ({
  value: code,
  text: regionNames.of(code) || code,
}));

const surveyJson = {
  completeText: "Submit",
  elements: [
    {
      type: "text",
      name: "userId",
      visible: false,
      inputType: "hidden",
    },
    {
      type: "panel",
      name: "mobile_number",
      title: "Please enter your Mobile Number:",
      elements: [
        {
          name: "country_code",
          type: "dropdown",
          titleLocation: "hidden",
          placeholder: "Select a country",
          // choicesByUrl: {
          //   url: "https://surveyjs.io/api/CountriesExample",
          // },
          // choicesByUrl: {
          //   url: "https://surveyjs.io/api/CountriesExample",
          //   valueName: "alpha2Code", // field name in API response
          //   titleName: "name", // field for label
          // },
          choices,
        },
        {
          type: "text",
          name: "phone_number",
          titleLocation: "hidden",
          inputType: "tel",
          width: "70%",
          startWithNewLine: false,
          minLength: 3,
          maxLength: 20,
          placeholder: "Enter your valid mobile number",
          validators: [
            {
              type: "regex",
              regex: "^[0-9]{3,20}$",
              text: "Please enter a valid mobile number.",
            },
          ],
          isRequired: true,
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question1",
      title: "1. How did you find us?",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      maxLength: 50,
      choices: [
        {
          value: "Through a friend",
          text: "Through a friend",
        },
        {
          value: "Scanned QR code",
          text: "Scanned QR code",
        },
        {
          value: "Link to Alopexia Website",
          text: "Link to Alopexia Website",
        },
        {
          value: "Referred by a Hairdresser",
          text: "Referred by a Hairdresser",
        },
      ],
      otherText: "Other",
      otherPlaceholder: "Please specify",
      showOtherItem: true,
    },
    {
      type: "radiogroup",
      name: "question2",
      title: "2. Which channel did you use for the test? ",
      renderAs: "radio",
      colCount: 0,
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      choices: [
        {
          value: "WhatsApp ",
          text: "WhatsApp ",
        },
        {
          value: "Computer (laptop or desktop)",
          text: "Computer (laptop or desktop)",
        },
        {
          value: "Mobile phone browser",
          text: "Mobile phone browser",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question3",
      title:
        "3. Was it easy to begin the test? (This refers to the entire process, beginning from learning about Alopexia to finally landing on the test screen)",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      choices: [
        {
          value: "Yes, it was easy ",
          text: "Yes, it was easy ",
        },
        {
          value: "No, I had difficulties ",
          text: "No, I had difficulties ",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question4",
      title: "4. Were you able to complete the test?  ",
      renderAs: "radio",
      isRequired: false,
      colCount: 0,
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      choices: [
        {
          value: "Yes  ",
          text: "Yes  ",
        },
        {
          value: "No ",
          text: "No ",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question4a",
      title: "4.1 If no, did you face difficulties due to:",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      choices: [
        {
          value: "I did not understand the instructions",
          text: "I did not understand the instructions",
        },
        {
          value: "I couldn't find the right camera angle or position",
          text: "I couldn't find the right camera angle or position",
        },
        {
          value: "The lighting or environment was not ideal for photos",
          text: "The lighting or environment was not ideal for photos",
        },
        {
          value: "I couldn't correct blurry or rejected photos",
          text: "I couldn't correct blurry or rejected photos",
        },
        {
          value: "Physical mobility issues (unable to lift camera/move neck)",
          text: "Physical mobility issues (unable to lift camera/move neck)",
        },
      ],
      otherText: "Other",
      otherPlaceholder: "Please specify",
      showOtherItem: true,
      visibleIf: "{question4} = 'No '",
    },
    {
      type: "radiogroup",
      name: "question5",
      title: "5. How clear were the instructions provided during the test? ",
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      choices: [
        {
          value: "Clear ",
          text: "Clear ",
        },
        {
          value: "Unclear ",
          text: "Unclear ",
        },
      ],
    },
    {
      type: "checkbox",
      name: "question6",
      title: "6. Which photo angle was the most difficult for you to click?",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      showCommentArea: true,
      commentText: "Why was it difficult?",
      commentPlaceholder: "Please specify the reason",
      choices: [
        {
          value: "Front",
          text: "Front",
        },
        {
          value: "Top",
          text: "Top",
        },
        {
          value: "Left",
          text: "Left",
        },

        {
          value: "Right",
          text: "Right",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question7",
      title:
        "7. Were the animations or video explanations helpful in understanding the steps? ",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      choices: [
        {
          value: "Helpful",
          text: "Helpful",
        },
        {
          value: "Not Helpful",
          text: "Not Helpful",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question8",
      title:
        "8. Was submitting your scalp photos easy? (This refers to uploading or sending the photos after taking them.)",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      cssClasses: {
        root: "surveyOptionswidth",
      },
      choices: [
        {
          value: "Yes, it was easy ",
          text: "Yes, it was easy ",
        },
        {
          value: "No, I had issues ",
          text: "No, I had issues ",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question9",
      title: "9. Was it easy to understand the result/report received?",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      choices: [
        {
          value: "Yes ",
          text: "Yes ",
        },
        {
          value: "No ",
          text: "No ",
        },
      ],
    },
    {
      type: "checkbox",
      name: "question10",
      title:
        "10. Please share your thoughts on the report: (Select all that apply)",
      isRequired: false,
      showCommentArea: true,
      commentText: "Tell us more:",
      commentPlaceholder: "Your comments",
      choices: [
        {
          value: "It was detailed and matched my expectations ",
          text: "It was detailed and matched my expectations  ",
        },
        {
          value: "It matched my results from previous scalp assessments",
          text: "It matched my results from previous scalp assessments",
        },
        {
          value:
            "I gained new insights about my current hair and scalp condition",
          text: "I gained new insights about my current hair and scalp condition",
        },
        {
          value:
            "It gave me enough information to decide on possible treatments for my condition",
          text: "It gave me enough information to decide on possible treatments for my condition",
        },
        {
          value: "It did not match my expectations",
          text: "It did not match my expectations",
        },
      ],
      otherText: "What additional information would you have liked to see?",
      otherPlaceholder: "Please specify",
      showOtherItem: true,
    },
    {
      type: "comment",
      name: "question11",
      title: "11. Did you experience any issues during the entire process?",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
    {
      type: "comment",
      name: "question12",
      title: "12. Do you have suggestions to improve the overall experience?",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
    {
      type: "comment",
      name: "question13",
      title:
        "13. Do you have any questions you would like to ask us about your results, the treatment options, or the next steps?",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
  ],
};
const surveyJsonFr = {
  completeText: "Soumettre",
  elements: [
    {
      type: "text",
      name: "userId",
      visible: false,
      inputType: "hidden",
    },
    {
      type: "panel",
      name: "mobile_number",
      title: "Veuillez saisir votre numéro de portable :",
      elements: [
        {
          name: "country_code",
          type: "dropdown",
          titleLocation: "hidden",
          placeholder: "Sélectionnez un pays",
          choicesByUrl: {
            url: "https://surveyjs.io/api/CountriesExample",
          },
        },
        {
          type: "text",
          name: "phone_number",
          titleLocation: "hidden",
          inputType: "tel",
          width: "70%",
          startWithNewLine: false,
          minLength: 3,
          maxLength: 20,
          placeholder: "Entrez votre numéro de mobile valide",
          validators: [
            {
              type: "regex",
              regex: "^[0-9]{3,20}$",
              text: "Veuillez saisir un numéro de mobile valide",
            },
          ],
          isRequired: true,
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question1",
      title: "1. Comment nous avez-vous trouvé?",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Par un ami",
          text: "Par un ami",
        },
        {
          value: "Code QR scanné",
          text: "Code QR scanné",
        },
        {
          value: "Lien vers le site Alpexia",
          text: "Lien vers le site Alopexia",
        },
        {
          value: "Recommandation de votre coiffeur",
          text: "Recommandation de votre coiffeur",
        },
      ],
      otherText: "Autre",
      otherPlaceholder: "Veuillez préciser",
      showOtherItem: true,
    },
    {
      type: "radiogroup",
      name: "question2",
      title: "2. Quelle technologie avez-vous utilisé pour passer le test?",
      renderAs: "radio",
      colCount: 0,
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "WhatsApp ",
          text: "WhatsApp ",
        },
        {
          value: "Ordinateur (portable ou fixe)",
          text: "Ordinateur (portable ou fixe)",
        },
        {
          value: "Téléphone portable (smartphone)",
          text: "Téléphone portable (smartphone)",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question3",
      title:
        "3. Était-il facile de débuter le test (entre le moment où vous avez appris l’existence de aloxa.ai et le début du test)?",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Oui, c’était facile ",
          text: "Oui, c’était facile ",
        },
        {
          value: "Non, j’ai eu des difficultés ",
          text: "Non, j’ai eu des difficultés ",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question4",
      title: "4. Avez-vous pu compléter le test? ",
      renderAs: "radio",
      isRequired: false,
      colCount: 0,
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Oui ",
          text: "Oui ",
        },
        {
          value: "Non ",
          text: "Non ",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question4a",
      title: "4.1 Si non, pourquoi :",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      choices: [
        {
          value: "Je n’ai pas compris les instructions",
          text: "Je n’ai pas compris les instructions",
        },
        {
          value: "Je n’ai pas trouvé le bon angle ou la bonne position",
          text: "Je n’ai pas trouvé le bon angle ou la bonne position",
        },
        {
          value: "L’éclairage n’était pas adéquat",
          text: "L’éclairage n’était pas adéquat",
        },
        {
          value: "Les photos floues/rejetées n’ont pas pu être corrigées",
          text: "Les photos floues/rejetées n’ont pas pu être corrigées",
        },
        {
          value:
            "Problèmes physiques ou de mobilité m’empêchant de photographier correctement",
          text: "Problèmes physiques ou de mobilité m’empêchant de photographier correctement",
        },
      ],
      otherText: "Autre ",
      otherPlaceholder: "Veuillez préciser",
      showOtherItem: true,
      visibleIf: "{question4} = 'No '",
    },
    {
      type: "radiogroup",
      name: "question5",
      title: "5. Les instructions étaient-elles claires? ",
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Claires ",
          text: "Claires ",
        },
        {
          value: "Pas claires ",
          text: "Pas claires ",
        },
      ],
    },
    {
      type: "checkbox",
      name: "question6",
      title: "6. Quelle photo a été la plus difficile à prendre?",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      showCommentArea: true,
      commentText: "o Pourquoi?",
      commentPlaceholder:
        "et comment avez vous fait pour résoudre ce problème?",
      choices: [
        {
          value: "Face",
          text: "Face",
        },
        {
          value: "Dessus",
          text: "Dessus",
        },
        {
          value: "Côté gauche",
          text: "Côté gauche",
        },

        {
          value: "Côté droit",
          text: "Côté droit",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question7",
      title:
        "7. Les animations et les vidéos de demonstration ont-elles été utiles? ",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Utiles",
          text: "Utiles",
        },
        {
          value: "Pas utiles",
          text: "Pas utiles",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question8",
      title: "8. Était-il facile de transmettre vos photos ?",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Oui ",
          text: "Oui ",
        },
        {
          value: "Non ",
          text: "Non ",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question9",
      title: "9. Le rapport a-t-il été facile à comprendre? ",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Oui ",
          text: "Oui ",
        },
        {
          value: "Non ",
          text: "Non ",
        },
      ],
    },
    {
      type: "checkbox",
      name: "question10",
      title: "10. Que pensez-vous du rapport ? (plusieurs réponses possibles)",
      isRequired: false,
      showCommentArea: true,
      commentText: "Dites-nous en plus:",
      commentPlaceholder: "Décrivez votre expérience",
      choices: [
        {
          value: "Détaillé et conforme à mes attentes ",
          text: "Détaillé et conforme à mes attentes  ",
        },
        {
          value: "Conforme à mes tests précédents",
          text: "Conforme à mes tests précédents",
        },
        {
          value: "J’ai appris de nouvelles choses sur ma chevelure",
          text: "J’ai appris de nouvelles choses sur ma chevelure",
        },
        {
          value:
            "Le rapport m’a donné assez d’info pour me convaincre d’essayer un traitement",
          text: "Le rapport m’a donné assez d’info pour me convaincre d’essayer un traitement",
        },
        {
          value: "Pas conforme à mes attentes.",
          text: "Pas conforme à mes attentes.",
        },
      ],
      otherText:
        "Je souhaiterais que le rapport comprenne des informations supplémentaires:",
      otherPlaceholder: "Veuillez préciser",
      showOtherItem: true,
    },
    {
      type: "comment",
      name: "question11",
      title:
        "11. Avez-vous eu des difficultés durant le processus? La durée du test vous paraît-elle acceptable?",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
    {
      type: "comment",
      name: "question12",
      title: "12. Des suggestions pour améliorer notre service? ",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
    {
      type: "comment",
      name: "question13",
      title:
        "13. Avez-vous des questions concernant vos résultats, les options de traitement ou les prochaines étapes?",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
  ],
};
const surveyJsonEs = {
  completeText: "Enviar",
  elements: [
    {
      type: "text",
      name: "userId",
      visible: false,
      inputType: "hidden",
    },
    {
      type: "panel",
      name: "mobile_number",
      title: "Por favor ingrese su número de móvil:",
      elements: [
        {
          name: "country_code",
          type: "dropdown",
          titleLocation: "hidden",
          placeholder: "Seleccione un país",
          choicesByUrl: {
            url: "https://surveyjs.io/api/CountriesExample",
          },
        },
        {
          type: "text",
          name: "phone_number",
          titleLocation: "hidden",
          inputType: "tel",
          width: "70%",
          startWithNewLine: false,
          minLength: 3,
          maxLength: 20,
          placeholder: "Ingrese su número de celular válido",
          validators: [
            {
              type: "regex",
              regex: "^[0-9]{3,20}$",
              text: "Por favor ingrese un número de celular válido",
            },
          ],
          isRequired: true,
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question1",
      title: "1. ¿Cómo nos conoció?",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "A través de un amigo",
          text: "A través de un amigo",
        },
        {
          value: "Código QR escaneado",
          text: "Código QR escaneado",
        },
        {
          value: "Enlace al sitio web de Alopexia",
          text: "Enlace al sitio web de Alopexia",
        },
        {
          value: "Recomendación de su peluquero",
          text: "Recomendación de su peluquero",
        },
      ],
      otherText: "Otro",
      otherPlaceholder: "Especifique",
      showOtherItem: true,
    },
    {
      type: "radiogroup",
      name: "question2",
      title: "2. ¿Qué tecnología utilizaste para hacer la prueba?",
      renderAs: "radio",
      colCount: 0,
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "WhatsApp ",
          text: "WhatsApp ",
        },
        {
          value: "Ordenador (portátil o de sobremesa)",
          text: "Ordenador (portátil o de sobremesa)",
        },
        {
          value: "Teléfono móvil (smartphone)",
          text: "Teléfono móvil (smartphone)",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question3",
      title:
        "3. ¿Fue fácil iniciar la prueba (entre el momento en que conociste aloxa.ai y el inicio de la prueba)?",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "Sí, fue fácil",
          text: "Sí, fue fácil",
        },
        {
          value: "No, tuve dificultades",
          text: "No, tuve dificultades",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question4",
      title: "4. ¿Pudo completar la prueba?",
      renderAs: "radio",
      isRequired: false,
      colCount: 0,
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "Sí",
          text: "Sí",
        },
        {
          value: "No",
          text: "No",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question4a",
      title: "4.1 En caso negativo, ¿por qué?",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      choices: [
        {
          value: "No entendí las instrucciones",
          text: "No entendí las instrucciones",
        },
        {
          value: "No pude encontrar el ángulo o la posición adecuados",
          text: "No pude encontrar el ángulo o la posición adecuados",
        },
        {
          value: "La iluminación no era adecuada",
          text: "La iluminación no era adecuada",
        },
        {
          value: "No se pudieron corregir las fotos borrosas/rechazadas",
          text: "No se pudieron corregir las fotos borrosas/rechazadas",
        },
        {
          value:
            "Problemas físicos o de movilidad me impidieron fotografiar correctamente",
          text: "Problemas físicos o de movilidad me impidieron fotografiar correctamente",
        },
      ],
      otherText: "Otros motivos",
      otherPlaceholder: "Especifique",
      showOtherItem: true,
      visibleIf: "{question4} = 'No'",
    },
    {
      type: "radiogroup",
      name: "question5",
      title: "5.¿Las instrucciones eran claras?",
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "Claras",
          text: "Claras",
        },
        {
          value: "Poco claras",
          text: "Poco claras",
        },
      ],
    },
    {
      type: "checkbox",
      name: "question6",
      title: "6. ¿Qué foto fue la más difícil de hacer?",
      isRequired: true,
      renderAs: "radio",
      colCount: 0,
      showCommentArea: true,
      commentText: "¿Por qué? y ¿cómo resolviste el problema?",
      commentPlaceholder: "Especifique",
      choices: [
        {
          value: "Frontal",
          text: "Frontal",
        },
        {
          value: "Parte superior",
          text: "Parte superior",
        },
        {
          value: "Lado izquierdo",
          text: "Lado izquierdo",
        },

        {
          value: "Lado derecho",
          text: "Lado derecho",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question7",
      title:
        "7. ¿Han sido útiles las animaciones y los vídeos de demostración?",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "Útiles",
          text: "Útiles",
        },
        {
          value: "No útiles",
          text: "No útiles",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question8",
      title: "8. ¿Fue fácil transmitir las fotos?",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "Sí",
          text: "Sí",
        },
        {
          value: "No",
          text: "No",
        },
      ],
    },
    {
      type: "radiogroup",
      name: "question9",
      title: "9. ¿Ha sido fácil de entender el informe?",
      isRequired: false,
      renderAs: "radio",
      colCount: 0,
      cssClasses: {
        root: "surveyOptionswidth",
      },
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "Sí",
          text: "Sí",
        },
        {
          value: "No",
          text: "No",
        },
      ],
    },
    {
      type: "checkbox",
      name: "question10",
      title: "10. ¿Qué le parece el informe? (se pueden dar varias respuestas)",
      isRequired: false,
      showCommentArea: true,
      commentText: "Cuéntanos más:",
      commentPlaceholder: "Describe tu experiencia",
      choices: [
        {
          value: "Detallado y conforme a mis expectativas",
          text: "Detallado y conforme a mis expectativas",
        },
        {
          value: "En línea con mis pruebas anteriores",
          text: "En línea con mis pruebas anteriores",
        },
        {
          value: "He aprendido cosas nuevas sobre mi cabello",
          text: "He aprendido cosas nuevas sobre mi cabello",
        },
        {
          value:
            "El informe me dio suficiente información para convencerme de probar el tratamiento",
          text: "El informe me dio suficiente información para convencerme de probar el tratamiento",
        },
        {
          value: "No es lo que esperaba. ¿Por qué no?",
          text: "No es lo que esperaba. ¿Por qué no?",
        },
      ],
      otherText: "Me gustaría que el informe incluyera información adicional",
      otherPlaceholder: "Especifique",
      showOtherItem: true,
    },
    {
      type: "comment",
      name: "question11",
      title:
        "11. ¿Ha tenido alguna dificultad durante el proceso? ¿Considera aceptable la duración de la prueba?",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
    {
      type: "comment",
      name: "question12",
      title: "12. ¿Tiene alguna sugerencia para mejorar nuestro servicio?",
      placeholder: "Please mention",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
    {
      type: "comment",
      name: "question13",
      title:
        "13. ¿Tiene alguna duda sobre sus resultados, las opciones de tratamiento o los próximos pasos?",
      placeholder: "Por favor mencione",
      // isRequired: true,
      renderAs: "radio",
      colCount: 0,
      minLength: 5,
      maxLength: 300,
      autoGrow: true,
      allowResize: false,
    },
  ],
};

function SurveyComponent({ onComplete }) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryName, setCountryName] = useState('')
  const [countryCode, setCountryCode] = useState("");
  const [currentLanguage, setCurrentLanguage] = useState(i18next.language);
  const [fullNumber, setFullNumber] = useState("");
  const [surveyModel, setSurveyModel] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const locale = useSelector((state) => state.language.langData);

  const getSurveyJson = () => {
    switch (currentLanguage) {
      case "fr":
        return surveyJsonFr;
      case "es":
        return surveyJsonEs;
      default:
        return surveyJson;
    }
  };

  useEffect(() => {
    if(localStorage.getItem("country-code") && localStorage.getItem("phno")){
      setCountryName(localStorage.getItem("country-code") && JSON.parse(localStorage.getItem("country-code")).country)
      let num = splitMobileNumber(localStorage.getItem("phno"))
      setPhoneNumber(num.mobileNumber)
    }
  }, [])

  useEffect(() => {
    // Function to get query parameters
    const params = new URLSearchParams(window.location.search);
    const { phno, country } = getHashQueryParams();

    if (phno && country) { 
      // Decrypt the phone number
      const decryptPhoneNum = (phone) => {
        return atob(decodeURIComponent(phone));
      };
      const decryptPhoNum = decryptPhoneNum(phno);
      setFullNumber(decryptPhoNum);
      const tempCountryCode = "+" + decryptPhoNum.slice(0, 2);
      setPhoneNumber(decryptPhoNum || "");
      setCountryCode(tempCountryCode || "");
      setCountryName(atob(decodeURIComponent(country)))
      window.location.href =  window.location.href.split("?")[0]
    }
  }, [window.location]);

  useEffect(() => {
    const handleLanguageChange = () => {
      if (i18next.language !== currentLanguage) {
        setCurrentLanguage(i18next.language);
      }
    };

    i18next.on("languageChanged", handleLanguageChange);
    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, [currentLanguage]);

  // useEffect(() => {
  //   const scrollTimeout = setTimeout(() => {
  //     window.scrollTo({ top: 0, behavior: "smooth" });
  //   }, 0); 

  //   return () => clearTimeout(scrollTimeout);
  // }, []);

  const splitMobileNumber = (input) => {
    const str = input.toString();
    const mobileNumber = str.slice(-10);
    const countryCode = str.slice(0, str.length - 10);
 
    // Basic validation
    if (mobileNumber.length !== 10 || isNaN(mobileNumber) || isNaN(countryCode)) {
      return { error: "Invalid input format" };
    }
 
    return {
      countryCode,
      mobileNumber
    };
  }

  const getHashQueryParams = () => {
    const hash = window.location.hash; // e.g., "#/feedback?phno=...&country=..."
    const queryIndex = hash.indexOf('?');
    if (queryIndex === -1) return {};

    const queryString = hash.substring(queryIndex + 1); // "phno=...&country=..."
    const params = new URLSearchParams(queryString);

    return {
      phno: params.get("phno"),
      country: params.get("country")
    };
  };

  const getCountryNameFromNumber = (number) => {
    try {
      const phoneNumber = parsePhoneNumberFromString(number, null, metadata);
      if (phoneNumber && phoneNumber.country) {
        const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
        let contactObj = {
          countryName: regionNames.of(phoneNumber.country), // e.g. "United States"
          countryCode: `+${phoneNumber.countryCallingCode}`, // e.g. "+1"
          nationalNumber: phoneNumber.nationalNumber, // e.g. "4155552671"
        };
        return contactObj;
        // return regionNames.of(phoneNumber.country); // returns country name
      }
      return "Invalid or unknown country";
    } catch (e) {
      return "Error parsing number";
    }
  };

  // const survey = useMemo(() => {
    // let index
    // if(phoneNumber && countryName){
    //   if(locale === "en"){
    //     surveyJson.elements.map((ele, idx) => {
    //       if(ele.name === "mobile_number"){
    //         index = idx
    //       }
    //     })
    //     surveyJson.elements.splice(index, 1)
    //   } else if (locale === "es") {
    //     surveyJsonEs.elements.map((ele, idx) => {
    //       if(ele.name === "mobile_number"){
    //         index = idx
    //       }
    //     })
    //     surveyJsonEs.elements.splice(index, 1)
    //   } else if (locale === "fr") {
    //     surveyJsonFr.elements.map((ele, idx) => {
    //       if(ele.name === "mobile_number"){
    //         index = idx
    //       }
    //     })
    //     surveyJsonFr.elements.splice(index, 1)
    //   }
    // }
  //   const model = new Model(getSurveyJson());
  //   let concatNum = "+" + fullNumber; // sample number +3488888899999
  //   model.data = {
  //     phone_number: phoneNumber, ///phoneNumber,
  //     country_code: countryName ? countryName : localStorage.getItem("country-code"),
  //     //  getCountryNameFromNumber(concatNum)["countryName"] || "Select country",
  //   };

  //   model.onAfterRenderQuestion.add(function (survey, options) {
  //     if (
  //       [
  //         "question1",
  //         "question3",
  //         "question5",
  //         "question7",
  //         "question8",
  //         "question9",
  //       ].includes(options.question.name)
  //     ) {
  //       const el = options.htmlElement;
  //       const applyClass = () => {
  //         if (!el.classList.contains("surveyOptionswidth")) {
  //           el.classList.add("surveyOptionswidth");
  //         }
  //       };
  //       applyClass();

  //       const observer = new MutationObserver(() => {
  //         applyClass();
  //       });
  //       observer.observe(el, {
  //         childList: true,
  //         subtree: true,
  //       });
  //     }
  //   });

  //   model.completedHtml = `
  //     <div class="submittedMessage" style="
  //       display: flex;
  //       flex-direction: column;
  //       align-items: center;
  //       justify-content: flex-start;
  //       padding: 30px;
  //       // height: 700px;
  //     ">
  //       <img src="/check.png" alt="Logo" style="max-width: 50px; margin-bottom: 20px;" />
  //       <h4>${i18next.t("Thank you for your valuable feedback!")}</h4>
  //     </div>
  //   `;

  //   return model;
  // }, [phoneNumber, countryCode, currentLanguage, locale]);

  const alertResults = useCallback(
    (survey) => {
      const now = new Date();
      const formattedId =
        now.getFullYear().toString() +
        "-" +
        String(now.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getDate()).padStart(2, "0") +
        ", " +
        String(now.getHours()).padStart(2, "0") +
        ":" +
        String(now.getMinutes()).padStart(2, "0") +
        ":" +
        String(now.getSeconds()).padStart(2, "0");

      const results = {
        ...survey.data,
        userId: formattedId,
        language_code: currentLanguage,
      };

      postData(results);
      setFormSubmitted(true)
      if (onComplete) onComplete();
    },
    [onComplete, currentLanguage]
  );

  const postData = async (results) => {
    try {
      await fetch(ALOXA_FEEDBACK_EXCEL_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(results),
      });
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    const initializeSurvey = () => {
      let index;

      if (phoneNumber && countryName) {
        if (locale === "en") {
          surveyJson.elements.forEach((ele, idx) => {
            if (ele.name === "mobile_number") {
              index = idx;
            }
          });
          if (index) {
            surveyJson.elements.splice(index, 1);
          } 
        } else if (locale === "es") {
          surveyJsonEs.elements.forEach((ele, idx) => {
            if (ele.name === "mobile_number") {
              index = idx;
            }
          });
          if (index) {
            surveyJson.elements.splice(index, 1);
          } 
        } else if (locale === "fr") {
          surveyJsonFr.elements.forEach((ele, idx) => {
            if (ele.name === "mobile_number") {
              index = idx;
            }
          });
          if (index) {
            surveyJson.elements.splice(index, 1);
          } 
        }
      }

      const model = new Model(getSurveyJson());

      model.data = {
        phone_number: phoneNumber,
        country_code: countryName || JSON.parse(localStorage.getItem("country-code")).country
      };

      model.onAfterRenderQuestion.add((survey, options) => {
        if (
          [
            "question1",
            "question3",
            "question5",
            "question7",
            "question8",
            "question9",
          ].includes(options.question.name)
        ) {
          const el = options.htmlElement;
          const applyClass = () => {
            if (!el.classList.contains("surveyOptionswidth")) {
              el.classList.add("surveyOptionswidth");
            }
          };
          applyClass();

          const observer = new MutationObserver(() => {
            applyClass();
          });
          observer.observe(el, {
            childList: true,
            subtree: true,
          });
        }
      });

      model.completedHtml = `
        <div class="submittedMessage" style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding: 30px;
        ">
          <img src="/check.png" alt="Logo" style="max-width: 50px; margin-bottom: 20px;" />
          <h4>${i18next.t("Thank you for your valuable feedback!")}</h4>
        </div>
      `;

      model.onComplete.add(alertResults); // ✅ Properly add onComplete here

      setSurveyModel(model);
    };

    initializeSurvey();
  }, [
    phoneNumber,
    countryName,
    locale,
    fullNumber,
    currentLanguage,
    alertResults, // 🔁 Needed because it's used in model
  ]);

  return (
    <>
      {
        surveyModel && !formSubmitted ? 
          <Survey model={surveyModel} /> 
            :
          <>
            <div class="submittedMessage"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                padding: "30px",
              }}
            >
              <img src="/check.png" alt="Logo" 
                style={{
                  maxWidth: "50px", 
                  marginBottom: "20px"
                }} />
              <h4>{i18next.t("Thank you for your valuable feedback!")}</h4>
            </div>
            <div 
              className="feedbackRedirection cursor-pointer" 
              onClick={() => window.open("https://alopexia.com/pages/home", "_self")}
            >
              <p>{i18next.t("Go to Home")}</p>
              <HomeIcon />
            </div>
          </>
      }
    </>
  );
}

function FeedBackForm() {
  const [isCompleted, setIsCompleted] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18next.language);
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  const locale = useSelector((state) => state.language.langData);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const langParam = searchParams.get("lang");

    // Handle URL language parameter
    if (langParam && ["en", "es", "fr"].includes(langParam)) {
      if (i18next.language !== langParam) {
        i18next.changeLanguage(langParam);
      }

      // Clean up URL by removing lang parameter
      searchParams.delete("lang");
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
        },
        { replace: true }
      );
    }

    // Set up i18next language change listener
    const handleLanguageChange = () => {
      setCurrentLang(i18next.language);
    };

    i18next.on("languageChanged", handleLanguageChange);

    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, [location.search, navigate, location.pathname]);

  useEffect(() => {
    logEvent('feedback_visited')
  }, [])

  const logEvent = async (event) => {
    try {
      await trackEvent(event, "success", " ", localStorage.getItem('phno'))
      await gTagTracking(event, {
        action: 'success',
        error: " ",
        mobile_number: localStorage.getItem('phno')
      })
    } catch (err) {
      console.log("err", err); 
      await trackEvent(event, "fail", err, localStorage.getItem('phno'))
      await gTagTracking(event, {
        action: 'fail',
        error: err,
        mobile_number: localStorage.getItem('phno')
      })
    }
  }

  const handleComplete = () => {
    setIsCompleted(true)
    logEvent('feedback_submitted')
  }

  return (
    <div className="feedbackContainer photo-container main-section-container">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center header"
        >
          <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv_feedbackform"
                onClick={() => navigate(-1)}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn_feedbackform"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={10}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Feedback Form")}
            </Typography>
          </Grid>
          {
            // ((location?.state?.from && location?.state?.from) || (location?.pathname === "/feedback" && isMobile)) &&
            <Grid item xs={1}>
              <Sidebar from={location?.state?.from != 'webheader' ? '' : location?.pathname}/>
            </Grid>
          }
        </Grid>

      <div className="subContainerSection">   
      <div className="feedbackFormHeader">
        {/* <h2>{i18next.t("User Feedback Form")}</h2>
        <Sidebar></Sidebar> */}
       
        {!isCompleted && (
          <div className="feedbackintroDiv">
            <p className="surveyIntropara">
              {i18next.t(
                "Thank you for participating in the Alopexia's AI-powered hair assessment system. Your feedback is vital to improving Alopexia AI's user experience for future users."
              )}
            </p>
            {/* <p className="surveyIntropara">
              {i18next.t(
                "As a thank you, beta testers who are eligible for hair regrowth solutions and can benefit from our compounded formulas will receive 4 months of treatment free of charge, following a review and prescription from our telemedicine doctors. We are also extending an invitation to the Centa Club. Club members receive exclusive offers and long-term discounts on Alopexia curated hair products."
              )}
            </p> */}
            {/* <p className="surveyIntropara">
              {i18next.t(
                "You're an important and valuable part of our journey, and we truly appreciate your insights."
              )}import MainLoader from './MainLoader';

            </p> */}
          </div>
        )}
      </div>

      <div className={locale === 'en' ? "survey-container feedbackForm eng" : "survey-container feedbackForm"}>
        <SurveyComponent onComplete={() => handleComplete()} />
      </div>
      </div> 
    </div>
  );
}

export default FeedBackForm;
